module.exports = __webpack_public_path__ + "static/media/Portrait-10059.8bbf92b0.jpg";